module.exports = __webpack_public_path__ + "static/bayerShowRural-efe8843e1936ac44fa7c7c674c82ad79.jpg";